import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      {/* Upper Footer Section */}
      <div className="footer-upper">
        <div className="footer-container">
          {/* Contact Information - Left Side */}
          <div className="footer-contact">
            <div className="contact-address">
              <p>125 Village Blvd</p>
              <p>Princeton NJ 08540</p>
            </div>
          </div>

          {/* Categorized Links - Right Side */}
          <div className="footer-links">
            {/* Industry Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">INDUSTRY</h3>
              <ul className="footer-column-links">
                <li><Link to="/finance-accounting/">Finance & Accounting</Link></li>
                <li><Link to="/healthcare/">Healthcare</Link></li>
                <li><Link to="/edtech/">EdTech</Link></li>
                <li><Link to="/pharmaceutical/">Pharmaceutical</Link></li>
              </ul>
            </div>

            {/* Our Services Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">OUR SERVICES</h3>
              <ul className="footer-column-links">
                <li><Link to="/aiml/">Artificial Intelligence And ML</Link></li>
                <li><Link to="/dataengineering/">Data Engineering</Link></li>
                <li><Link to="/generativeai/">Generative AI</Link></li>
                <li><Link to="/softwareengineering/">Software Engineering For AI Products</Link></li>
              </ul>
            </div>

            {/* Products Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">PRODUCTS</h3>
              <ul className="footer-column-links">
                <li><Link to="/products/#research">Catalyst Research</Link></li>
                <li><Link to="/products/#curriculum">Catalyst Curriculum</Link></li>
                <li><Link to="/products/#workforce">Catalyst Workforce</Link></li>
              </ul>
            </div>

            {/* Company Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">COMPANY</h3>
              <ul className="footer-column-links">
                <li><Link to="/company/">About Us</Link></li>
                <li><Link to="/contact/">Careers</Link></li>
              </ul>
            </div>

            {/* Support Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">SUPPORT</h3>
              <ul className="footer-column-links">
                <li><Link to="/contact/">Contact Us</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Separator Line */}
      <div className="footer-separator"></div>

      {/* Lower Footer Section */}
      <div className="footer-lower">
        <div className="footer-container">
          {/* Copyright - Left Side */}
          <div className="footer-copyright">
            <p>{`© ${new Date().getFullYear()} Zemantics LLC. All rights reserved.`}</p>
          </div>

          {/* Privacy Policy - Right Side */}
          <div className="footer-privacy">
            <Link to="/privacy-policy/">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 